<div class="mat-dialog-containers">
  <div mat-dialog-title class="mat-dialog-title">
    <span class="mat-dialog-title-style">{{data.title || 'Cerrar Cotización'}}</span>
    <button mat-icon-button aria-label="close" class="close-button" (click)="onCancel()">✕</button>
  </div>

  <div mat-dialog-content class="mat-dialog-content">

    <div class="field-row mt-10">
      <label class="field-label">Venta Ganada</label>
      <mat-radio-group [(ngModel)]="selectedValue" class="radio-group" (change)="onRadioChange($event.value)">
        <mat-radio-button style="margin: 0% !important; padding: 0% !important;" value="SI"
          color="primary">Sí</mat-radio-button>
        <mat-radio-button value="NO" color="primary">No</mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- Sección SI: Radicación -->
    <ng-container *ngIf="selectedValue === 'SI'">
      
      <!-- Flujo para cotizaciones INDIVIDUALES -->
      <ng-container *ngIf="tipoContrato === 'individual'">
        <div *ngIf="isLoadingVentaGanada" style="display:flex; justify-content:center; padding:24px;">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <div *ngIf="errorVentaGanada && !isLoadingVentaGanada" style="display:flex; flex-direction:column; align-items:center; padding:16px; gap:12px;">
          <span style="color:#d32f2f;">No se pudo cargar la información. Intente nuevamente.</span>
          <button mat-stroked-button color="warn" (click)="cargarBeneficiariosVentaGanada()">Reintentar</button>
        </div>

        <ng-container *ngIf="!isLoadingVentaGanada && !errorVentaGanada">
          <ng-container *ngIf="beneficiariosVentaGanada.length > 0; else sinBeneficiarios">
            <div class="info-message">
              <mat-icon style="color: #1976d2;">info</mat-icon>
              <span>Elija un programa por línea de negocio para pasar a radicación</span>
            </div>

            <div *ngFor="let beneficiario of beneficiariosVentaGanada" class="beneficiario-section">
              <h3 class="beneficiario-nombre">{{beneficiario.nombreCompleto}}</h3>

              <div class="lineas-negocio-container">
                <div *ngFor="let linea of beneficiario.lineasNegocio" class="linea-negocio-col">
                  <label class="linea-label">{{linea.lineaNegocio}}</label>
                  <mat-form-field appearance="outline" class="linea-select">
                    <mat-select [(ngModel)]="linea.programaSeleccionadoId">
                      <mat-option *ngFor="let programa of linea.programas" [value]="programa.idBenPrograma">
                        {{programa.nombrePrograma}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #sinBeneficiarios>
            <div style="display:flex; align-items:center; gap:10px; padding:16px; background:#fff8e1; border-radius:6px; margin-top:14px;">
              <mat-icon style="color:#f9a825; flex-shrink:0; width:24px; height:24px; font-size:24px; line-height:24px;">info_outline</mat-icon>
              <span style="color:#5d4037;">Esta cotización no tiene beneficiarios con programas asociados para enviar a radicación.</span>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>

      <!-- Flujo para cotizaciones COLECTIVAS -->
      <ng-container *ngIf="tipoContrato === 'colectivo'">
        <div *ngIf="isLoadingVentaGanada" style="display:flex; justify-content:center; padding:24px;">
          <mat-spinner diameter="32"></mat-spinner>
        </div>

        <div *ngIf="errorVentaGanada && !isLoadingVentaGanada" style="display:flex; flex-direction:column; align-items:center; padding:16px; gap:12px;">
          <span style="color:#d32f2f;">No se pudo cargar la información. Intente nuevamente.</span>
          <button mat-stroked-button color="warn" (click)="cargarBeneficiariosVentaGanada()">Reintentar</button>
        </div>

        <ng-container *ngIf="!isLoadingVentaGanada && !errorVentaGanada">
          <ng-container *ngIf="programasColectivoData.length > 0; else sinProgramasColectivo">
            <div class="field-row" style="margin-top: 18px;">
              <label class="field-label">% Subsidio:</label>
              <mat-form-field appearance="outline" class="full-width" style="margin-left:8px;">
                <input matInput [value]="subsidioColectivo" readonly>
              </mat-form-field>
            </div>

            <div class="programas-colectivos-section">
              <div class="programa-item" *ngFor="let prog of programasColectivoData; let i = index">
                <div class="programa-row">
                  <div class="programa-field">
                    <label class="programa-label">Programa {{i + 1}}</label>
                    <mat-form-field appearance="outline" class="programa-input">
                      <input matInput [value]="prog.nombrePrograma" readonly>
                    </mat-form-field>
                  </div>
                  <div class="linea-field">
                    <label class="linea-label-col">Línea</label>
                    <mat-form-field appearance="outline" class="linea-input">
                      <input matInput [value]="prog.lineaNegocio" readonly>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-template #sinProgramasColectivo>
            <div style="display:flex; align-items:center; gap:10px; padding:16px; background:#fff8e1; border-radius:6px; margin-top:14px;">
              <mat-icon style="color:#f9a825; flex-shrink:0; width:24px; height:24px; font-size:24px; line-height:24px;">info_outline</mat-icon>
              <span style="color:#5d4037;">Esta cotización no tiene programas asociados para mostrar. Puede continuar con el cierre de radicación.</span>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
      
    </ng-container>

    <!-- Sección NO: Motivo y Observaciones -->
    <ng-container *ngIf="selectedValue === 'NO'">
      <div class="field-row" style="margin-top: 18px; flex-direction: column; align-items: flex-start;">
        <mat-label>Motivo de Cierre *</mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <mat-select [(ngModel)]="motivoCierre" (selectionChange)="onMotivoChange()">
            <mat-option *ngFor="let motivo of motivosCierre" [value]="motivo">
              {{motivo.descripcion}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="motivoTouched && !motivoCierre">Debes seleccionar un motivo de cierre.</mat-error>
        </mat-form-field>
      </div>
      <div class="field-row" style="margin-top: 8px; flex-direction: column; align-items: flex-start;">
        <mat-label>Observaciones</mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <textarea matInput [(ngModel)]="observaciones" maxlength="500" rows="3"
            (ngModelChange)="onObservacionesChange()"></textarea>
          <mat-hint align="end">{{observaciones.length || 0}} / 500</mat-hint>
          <mat-error *ngIf="observacionesError">Máximo 500 caracteres.</mat-error>
        </mat-form-field>
      </div>
    </ng-container>
  </div>

  <div mat-dialog-actions class="mat-dialog-actions">
    <button mat-raised-button color="primary" (click)="onConfirm()"
      [disabled]="isButtonDisabled()">
      <mat-spinner *ngIf="isLoading" diameter="18" style="display:inline-block; margin-right:8px;"></mat-spinner>
      {{getButtonText()}}
    </button>
  </div>
</div>